"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const react_1 = __importDefault(require("react"));
const Loader = ({ height, className, src, testing }) => {
    return (react_1.default.createElement("div", { className: `flex justify-center ${className}`, "data-testid": testing && 'loader-wrapper' },
        react_1.default.createElement("img", { src: src, alt: "loading", height: height ? `${height}px` : '100px' })));
};
exports.Loader = Loader;
